
import { formatNumber } from '../../assets/js/utils/math'
import DownloadAlertButton from './DownloadAlertButton'
import LocaleChanger from './LocaleChanger'

export default {
  name: 'AlertDetails',
  components: { LocaleChanger, DownloadAlertButton },
  props: {
    alert: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      selectedIndex: 0,
      language: 'en',
      previewVideo: ''
    }
  },
  computed: {
    availableLanguages () {
      if (!this.alert.locale_configs) {
        return []
      }

      return this.alert.locale_configs.map(config => config.locale)
    },
    styleCategories () {
      if (this.alert && this.alert.style_categories && this.alert.style_categories.length > 0) {
        return this.alert.style_categories.map(s => s.name).slice(0, 3).join(' • ')
      }

      return null
    },
    eventCategory () {
      if (this.alert && this.alert.event_categories && this.alert.event_categories.length > 0) {
        return this.alert.event_categories[0].name
      }

      return null
    }
  },
  watch: {
    language () {
      this.updateShowcase()
    }
  },
  created () {
    this.updateShowcase()

    if (this.availableLanguages.includes(this.$i18n.locale)) {
      this.language = this.$i18n.locale
    }
  },
  methods: {
    formatNumber,
    updateShowcase () {
      this.previewVideo = this.alert.locale_configs
        .find(config => config.locale === this.language)
        .preview_video_url
    }
  }
}
